import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({ providedIn: 'root' })
export class OrdenesConvenioService {

  private readonly base = '/transactions/agreement-orders';

  constructor(private api: ApiService) {}

  // `token` es legacy y se ignora (el token va en el header Bearer).

  listarOrdenes(_token: string, params: any): Observable<{ data: any[]; recordsTotal: number; recordsFiltered: number }> {
    return this.api.post(`${this.base}/list`, {
      fechaInicio: params.fechaInicio,
      fechaFin: params.fechaFin,
      doctor: params.doctor,
      sucursal: params.sucursal,
      start: params.start || 0,
      length: params.length || 10,
      search: params.search || ''
    });
  }

  catalogos(_token: string): Observable<{ sucursales: any[]; doctores: any[] }> {
    return this.api.post(`${this.base}/catalogs`, {});
  }

  obtenerFactura(_token: string, ordenes: string, doctor: string): Observable<any> {
    return this.api.post(`${this.base}/invoice`, { ordenes, doctor });
  }
}
